import { ELF_RIG_VERSION, elfProportions, elfStandardHeight, morphElfProportions } from '../../../content/characters/rigs/elf.js';
import type { UnitDefinition } from '../../../shared/game/world-types.js';
import { mix } from '../../../content/characters/rigs/human.js';
import { createHumanoidModel, type HumanModelOptions } from './human-model.js';

/** Elf anatomy is a morph of the shared humanoid assembly; its head changes layer over the matching Human anatomy. */
export function createElfModel(definition: UnitDefinition, options?: HumanModelOptions) {
  const look = definition.appearance;
  if (!look || look.ancestry !== 'elf') throw new Error('The Elf model requires Elf appearance content.');
  const p = morphElfProportions(elfProportions(look.rig), look.parts?.face);
  const rig = createHumanoidModel({ ...definition, appearance: { ...look, height: look.height ?? elfStandardHeight(p.id) } }, p, options,
    { face: p.face, palette: { eye: 0x6e9b80, lips: mix(look.skin, 0x7b5265, .3) } });
  rig.root.userData.nimblezRigVersion = ELF_RIG_VERSION;
  return rig;
}
